<div class="load-more-info" [class.center]="isCenter" *ngIf="cardsLength">
  {{ cardsLength }}
  {{ 'label.showing' | translate }}
  {{ allItemsLength }}
  {{ 'label.of' | translate }}
</div>
